import { ModalEnum } from '../../../../app/core/helpers/modal/modal.enum';
import { IServiceResponseMenuItemType } from '../../../../app/core/models/services/response-app/response-app-menu-item.interface';
import { IServiceResponseNavigationTree } from '../../../../app/core/models/services/response-app/response-app.interface';
import { Item } from '../item.model';

export class MenuItemsModel {
  menuStructure: Item[] = [];

  constructor(data: IServiceResponseNavigationTree) {
    this.parse(data);
  }

  /**
   * Parses menu items based on header model
   * @param data Data from API to assembly menu
   * @returns Parsed data on Item[] format
   */
  parse(data: IServiceResponseNavigationTree): Item[] {
    this.menuStructure = data.menu.filter((menu) => menu.tipo_pagina !== 3).map((page) => this.parsePage(page));
    return this.menuStructure;
  }

  parsePage(page: IServiceResponseMenuItemType): Item {
    return {
      label: page.descricao,
      path: this.getPath(page),
      icon: page.icone,
      sub_menus: page?.sub_menus?.map((submenu) => this.parseSubpages(submenu))
    };
  }

  parseSubpages(submenu: IServiceResponseMenuItemType) {
    return {
      title: submenu.descricao,
      path: submenu.path ?? `${ModalEnum.MODAL_PREFIX}${submenu.widget_tag}`
    };
  }

  getPath(page: IServiceResponseMenuItemType): string | undefined {
    return page.path || (page.widget_tag ? `${ModalEnum.MODAL_PREFIX}${page.widget_tag}` : undefined);
  }
}
